// extracted by mini-css-extract-plugin
module.exports = {"bristol":"FormularioAvaliacaoClinica_bristol__1v11t","imagemBristol":"FormularioAvaliacaoClinica_imagemBristol__3pvNj"};